import { render, staticRenderFns } from "./MusicPreview.vue?vue&type=template&id=7b55ea82"
import script from "./MusicPreview.vue?vue&type=script&lang=js"
export * from "./MusicPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b55ea82')) {
      api.createRecord('7b55ea82', component.options)
    } else {
      api.reload('7b55ea82', component.options)
    }
    module.hot.accept("./MusicPreview.vue?vue&type=template&id=7b55ea82", function () {
      api.rerender('7b55ea82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/nieuwsmaker/components/MusicPreview.vue"
export default component.exports